module.exports = __webpack_public_path__ + "static/media/envelope.c89db702.png";